import { Box, Rating, Stack, Typography } from "@mui/material";
import React from "react";
import COLORS from "../../../constants/colors";
import StarOutlineFilled from "../../icons/StarOutlineFilled";
import StarOutlineEmpty from "../../icons/StarOutlineEmpty";
import Display from "../../layout/Display";

export interface IAppReview {
  title: string;
  content: string;
  starsNr: number;
  reviewerName: string;
  dateOfReview: string;
}

const ReviewRating = ({ rating }: { rating: number }) => (
  <Rating
    precision={0.5}
    readOnly
    value={rating}
    size="small"
    icon={
      <Box pr="4px">
        <StarOutlineFilled fontSize="inherit" />
      </Box>
    }
    emptyIcon={
      <Box pr="4px">
        <StarOutlineEmpty fontSize="inherit" />
      </Box>
    }
  />
);

const MobileVersion = ({
  title: commentTitle,
  content: commentContent,
  starsNr,
  reviewerName,
  dateOfReview,
}: IAppReview) => (
  <Stack spacing="24px">
    <Stack>
      <Typography variant="h4" color={COLORS.DARK_BLUE[100]}>
        {commentTitle}
      </Typography>
      <ReviewRating rating={starsNr} />
    </Stack>
    <Typography color={COLORS.DARK_BLUE[100]} variant="body">
      {commentContent}
    </Typography>
    <Stack direction="row" gap="8px">
      <Typography
        variant="label"
        color={COLORS.DARK_BLUE[100]}
        textAlign="end"
        fontWeight="bold"
        whiteSpace="nowrap"
      >
        {dateOfReview}
      </Typography>
      <Typography variant="label" color={COLORS.DARK_BLUE[100]} textAlign="end">
        {reviewerName}
      </Typography>
    </Stack>
  </Stack>
);

const DesktopVersion = ({
  title: commentTitle,
  content: commentContent,
  starsNr,
  reviewerName,
  dateOfReview,
}: IAppReview) => (
  <Stack spacing="24px">
    <Box>
      <Stack direction="row" justifyContent="space-between">
        <Stack>
          <Typography variant="h4" color={COLORS.DARK_BLUE[100]}>
            {commentTitle}
          </Typography>
          <ReviewRating rating={starsNr} />
        </Stack>
        <Stack>
          <Typography
            variant="label"
            color={COLORS.DARK_BLUE[100]}
            textAlign="end"
            fontWeight="bold"
            whiteSpace="nowrap"
          >
            {dateOfReview}
          </Typography>
          <Typography
            variant="label"
            color={COLORS.DARK_BLUE[100]}
            textAlign="end"
          >
            {reviewerName}
          </Typography>
        </Stack>
      </Stack>
    </Box>
    <Typography color={COLORS.DARK_BLUE[100]} variant="body">
      {commentContent}
    </Typography>
  </Stack>
);

const AppReviewDisplayCard = (props: IAppReview) => {
  return (
    <Box
      p="48px"
      bgcolor={COLORS.WHITE[100]}
      borderRadius="20px"
      display="flex"
      flex="1"
    >
      <Display desktop>
        <DesktopVersion {...props} />
      </Display>
      <Display mobile>
        <MobileVersion {...props} />
      </Display>
    </Box>
  );
};
export default AppReviewDisplayCard;
